import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ContactTopic, InfoPerso } from '../models/InfoPerso.model';
import { environment } from '@env/environment';
import { COUNTRIES } from '../../../config/countries';
import { Observable, throwError } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
import { GS1NotificationLevel, GS1NotificationService } from '@gs1france/gs1-components-library';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class FormulaireDonneePersoService {
  __URL_API__ = `${environment.URL_API}`;

  private _http = inject(HttpClient);
  private notificationService = inject(GS1NotificationService);
  private translate = inject(TranslateService);
  private router = inject(Router);

  getInfoPerso(): Observable<InfoPerso> {
    return this._http.get<InfoPerso>(this.__URL_API__ + 'api/Contact/GetContact').pipe(
      take(1),
      catchError((error) => this.handleError(error))
    );
  }

  UpdateInfosPerso(form: InfoPerso): Observable<string> {
    let countryCode = '';
    if (form.pays) {
      countryCode =
        COUNTRIES.find((country: any) => country.alpha2Code.toUpperCase() == form.pays.toUpperCase())?.alpha2Code ?? '';
      form.pays = countryCode;
    }

    return this._http.put<string>(this.__URL_API__ + 'api/Contact/Update', form).pipe(
      take(1),
      tap(() => this.sendNotif('Formulaire.Notifications.success', 'success')),
      catchError((error) => this.handleError(error, 'Formulaire.Notifications.error'))
    );
  }

  public getSubscriptions() {
    const response = ['Actualités GS1 France', 'Informations et actualités Standardisation', 'Evnéments et webinaires'];
    return response;
  }

  private sendNotif(message: string, level: GS1NotificationLevel) {
    this.notificationService.addNotification(this.translate.instant(message), level);
  }

  private handleError(error: any, msg?: string): Observable<never> {
    if (error && error.error && error.error.includes('dont have acces to')) {
      this.router.navigate(['/unauthorizedContact/CLI-01']);
    }
    if (msg) {
      this.sendNotif(msg, 'error');
    }
    return throwError(() => error.message || error);
  }

  getTopics(): Observable<ContactTopic[]> {
    return this._http.get<ContactTopic[]>(this.__URL_API__ + 'api/Contact/GetTopics').pipe(
      take(1),
      catchError((error) => this.handleError(error))
    );
  }
}
